import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, output, OutputEmitterRef, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { IconComponent } from '@libs/components/icons';
import { OverlayDirective } from './overlay.directive';

@Component({
  selector: 'ui-overlay',
  templateUrl: 'overlay.component.html',
  styleUrls: ['overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    OverlayDirective,
    NgTemplateOutlet,
    MatButtonModule,
    MatCardModule,
    IconComponent,
  ],
})
export class OverlayComponent {
  @Input() public contentTemplate!: TemplateRef<unknown>;
  @Input() public title!: string;
  @Input() public contentClass: string = '';
  @Input() public name: string = '';
  @Input() public showHeader: boolean = true;
  @ViewChild(OverlayDirective) public overlayRoot!: OverlayDirective;

  public overlayShown: OutputEmitterRef<void> = output();
  public overlayClosed: OutputEmitterRef<void> = output();

  public open(): void {
    this.overlayRoot.show();
    this.overlayShown.emit();
  }

  public close(emit?: boolean): void {
    this.overlayRoot.close();

    if (emit) {
      this.overlayClosed.emit();
    }
  }
}
